module.exports = __webpack_public_path__ + "img/248-e0b7d6.png";